package com.exura.features.plandefinition.data.repository

import com.exura.features.firebase.data.repository.BaseFirestoreRepository
import com.exura.features.plandefinition.data.mappers.plandefinition.CollectionMappers
import com.exura.features.plandefinition.data.remote.dto.collection.CollectionDto
import com.exura.features.plandefinition.domain.model.collection.Collection
import com.exura.features.plandefinition.domain.repository.PlanCollectionRepository
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.FirebaseFirestore
import kotlinx.serialization.modules.SerializersModule

class PlanCollectionRepositoryImpl(
    firestore: FirebaseFirestore,
    dtoSerializersModule: SerializersModule,
    mapper: CollectionMappers,
) : PlanCollectionRepository, BaseFirestoreRepository<Collection, CollectionDto>(
    firestore = firestore,
    dtoSerializersModule = dtoSerializersModule,
    mapper = mapper,
) {
    override suspend fun addDto(dto: CollectionDto, dest: CollectionReference): DocumentReference =
        dest.add(dto) { serializersModule = dtoSerializersModule }

    override suspend fun getDto(doc: DocumentSnapshot): CollectionDto = doc.data { serializersModule = dtoSerializersModule }

    override suspend fun setDto(dto: CollectionDto, dest: DocumentReference): DocumentReference {
        dest.set(dto) { serializersModule = dtoSerializersModule }
        return dest
    }
}
